'use strict';

var DataRangeFilterFactory = function DataRangeFilterFactory() {
  function DataRangeFilter(sourceType, filterType, priority) {
    this.sourceType = sourceType;
    this.filterType = filterType;
    this.priority = priority || 0;
  }
  DataRangeFilter.prototype.filter = function (data, range) {
    var self = this;
    var filterFunction = self.filterGroup(range);
    var cachedResult = {};
    var results = [];
    if (Array.isArray(range) && range.length >= 1) {
      for (var i = 0, length = data.length; i < length; i++) {
        var element = data[i];
        var departureDate = element[self.groupBy];
        var cacheKey = departureDate.valueOf();
        var filterResult = cachedResult[cacheKey];
        if (filterResult === undefined) {
          filterResult = filterFunction(departureDate);
          cachedResult[cacheKey] = filterResult;
        }
        if (filterResult === true) {
          results.push(element);
        }
      }
      return results;
    } else {
      return data;
    }
  };
  DataRangeFilter.prototype.getFilterType = function () {
    return this.filterType;
  };
  DataRangeFilter.prototype.filterGroup = function (dateRange) {
    return function (departureDate) {
      for (var i = 0, len = dateRange.length; i < len; i++) {
        var val = dateRange[i];
        if (!departureDate.isBefore(val.from) && !departureDate.isAfter(val.to)) {
          return true;
        }
      }
    };
  };
  DataRangeFilter.prototype.canFilter = function (sourceType, filterType) {
    var self = this;
    if (Array.isArray(self.sourceType)) {
      return self.sourceType.indexOf(sourceType) !== -1 && self.filterType === filterType;
    } else {
      return self.sourceType === sourceType && self.filterType === filterType;
    }
  };
  return DataRangeFilter;
};
DataRangeFilterFactory.$inject = [];
module.exports = DataRangeFilterFactory;